module.exports = __webpack_public_path__ + "img/pc.81b236fb.png";